"use client";

import { ServerTool } from "@/components/ServerTool";
import { kindOf, withExtension } from "@/lib/files";
import { getTool } from "@/lib/tools";

const tool = getTool("office-to-pdf")!;

/** Word, Excel, PowerPoint to PDF (Phase 5, server): LibreOffice converts. */
export function OfficeToPdfTool() {
  return (
    <ServerTool
      tool={tool}
      job="office-to-pdf"
      options={(file) => ({ ext: kindOf(file) })}
      button="Convert to PDF"
      result={(file, blob) => ({
        blob,
        name: withExtension(file.name, "pdf"),
      })}
    >
      <p className="text-sm text-ink">
        The PDF keeps your layout, fonts and pictures. Fonts we don&apos;t have
        are swapped for close matches, so check the result before you send it.
      </p>
    </ServerTool>
  );
}
